import React from "react";
import { Navigate, Route, RouteProps } from "react-router-dom";

// components
import PrivateRoute from "./PrivateRoute";
// import Root from "./Root";

// lazy load all the views

// auth
// const Login = React.lazy(() => import("../pages/auth/Login"));
const MobileLogin = React.lazy(() => import("../pages/auth/MobileLogin"));
const MobileSignup = React.lazy(() => import("../pages/auth/MobileSignup"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const Confirm = React.lazy(() => import("../pages/auth/Confirm"));
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const Register = React.lazy(() => import("../pages/auth/Register"));
const LockScreen = React.lazy(() => import("../pages/auth/LockScreen"));

//channel routes
const CreateChannel = React.lazy(
  () => import("../pages/channelDetails/CreateChannel")
);
const CreatorAgreement = React.lazy(
  () => import("../pages/channelDetails/CreatorAgreement")
);

// const TermsCondition = React.lazy(
//   () => import("../pages/channelDetails/TermsConditions")
// );

// landing
const Landing = React.lazy(() => import("../pages/landing/"));

// New Pages

const WatchoDashboard = React.lazy(() => import("../pages/dashboards/"));
// const ContentManagement = React.lazy(
//   () => import("../pages/content-management/")
// );
const Analytics = React.lazy(() => import("../pages/analytics/"));
const Monetization = React.lazy(() => import("../pages/monetization/"));

const Monetisation = React.lazy(
  () => import("../pages/monetization/Monitisation")
);
const CreatorInfo = React.lazy(() => import("../pages/creatorinfo"));

//Payment Invoice
const PaymentPage = React.lazy(
  () => import("../pages/paymentDetails/PaymentPage")
);
const PayoutDetailsPage = React.lazy(
  () => import("../pages/paymentDetails/PayoutDetails")
);
const PayoutLogs = React.lazy(
  () => import("../pages/paymentDetails/PayoutLogs")
);

const UpdateKyc = React.lazy(() => import("../pages/monetization/UpdateKyc"));
const ManageKyc = React.lazy(() => import("../pages/kyc/ProfileKyc"));

const Promotion = React.lazy(() => import("../pages/promotions/"));
const ChannelCustomization = React.lazy(
  () => import("../pages/channel-customization/")
);
const ChannelSocialMedia = React.lazy(
  () => import("../pages/channel-customization/ChannelSocialMedia")
);
const ProfileSetting = React.lazy(() => import("../pages/profile-setting/"));
const Help = React.lazy(() => import("../pages/help/"));
const GettingStartedPage = React.lazy(
  () => import("../pages/help/HomeLinkOne")
);
const GettingStartedQuestions = React.lazy(
  () => import("../pages/help/HomeLinkTwo")
);
const GettingStartedChannel = React.lazy(
  () => import("../pages/help/HomeLinkThree")
);
const GettingStartedContent = React.lazy(
  () => import("../pages/help/HomeLinkFour")
);
const GettingStartedTroubleshoot = React.lazy(
  () => import("../pages/help/HomeLinkFive")
);
const ChannelSubscription = React.lazy(
  () => import("../pages/help/ChannelSub")
);
const PolicyDocuments = React.lazy(
  () => import("../pages/help/PolicyDocument")
);
const FaqDocuments = React.lazy(() => import("../pages/help/Faq"));

const PolicyPrivacy = React.lazy(() => import("../pages/help/PolicyPrivacy"));
const PolicyTerms = React.lazy(() => import("../pages/help/PolicyTerms"));
const ContentUpload = React.lazy(() => import("../pages/help/ContentUpload"));
const Support = React.lazy(() => import("../pages/help/Support"));
const SupportOpenTicket = React.lazy(() => import("../pages/help/OpenTicket"));

const ContentTerms = React.lazy(() => import("../pages/help/ContentTerms"));
const ContentPrivacy = React.lazy(() => import("../pages/help/ContentPrivacy"));
const ContentCreatorPrivacyPolicy = React.lazy(
  () => import("../pages/help/ContentCreatorPrivacyPolicy")
);
const ContentGuidelinesPolicy = React.lazy(
  () => import("../pages/help/ContentGuidelinesPolicy")
);
const ContentTakeDownPoilcy = React.lazy(
  () => import("../pages/help/ContentTakeDownPoilcy")
);
const ContentCreatorAgreement = React.lazy(
  () => import("../pages/help/ContentCreatorAgreement")
);
const MonetizationPrivacy = React.lazy(
  () => import("../pages/help/MonetizationPrivacy")
);

const DoDonts = React.lazy(() => import("../pages/help/DoDonts"));

const ContentMonitisation = React.lazy(
  () => import("../pages/help/ContentMonitisation")
);
const ContentUploadPrivacy = React.lazy(
  () => import("../pages/help/ContentUploadPrivacy")
);

const Feedback = React.lazy(() => import("../pages/feedback/"));

const Notification = React.lazy(
  () => import("../pages/notification/NotificationList")
);

// // dashboard
// const EcommerceDashboard = React.lazy(
//   () => import("../pages/dashboard/Ecommerce/")
// );
// const AnalyticsDashboard = React.lazy(
//   () => import("../pages/dashboard/Analytics/")
// );

const Content = React.lazy(() => import("../pages/ContentManagement"));
const UpdateVideoContent = React.lazy(
  () => import("../pages/ContentManagement/UpdateVideoContent")
);
const UpdateShortsContent = React.lazy(
  () => import("../pages/ContentManagement/UpdateShortsContent")
);
const UpdateLiveEventContent = React.lazy(
  () => import("../pages/ContentManagement/UpdateLiveEventContent")
);
const SeriesDetails = React.lazy(
  () => import("../pages/ContentManagement/SeriesDetails")
);
// const Monetization = React.lazy(() => import("../pages/monetization"));
// apps
const CalendarApp = React.lazy(() => import("../pages/apps/Calendar/"));
const Projects = React.lazy(() => import("../pages/apps/Projects/"));
const ProjectDetail = React.lazy(
  () => import("../pages/apps/Projects/Detail/")
);
// - chat
const ChatApp = React.lazy(() => import("../pages/apps/Chat/"));
// - email
const Inbox = React.lazy(() => import("../pages/apps/Email/Inbox"));
const EmailDetail = React.lazy(() => import("../pages/apps/Email/Detail"));
const EmailCompose = React.lazy(() => import("../pages/apps/Email/Compose"));
// - tasks
const TaskList = React.lazy(() => import("../pages/apps/Tasks/List/"));
const Kanban = React.lazy(() => import("../pages/apps/Tasks/Board/"));
// - file
const FileManager = React.lazy(() => import("../pages/apps/FileManager"));

// extra pages
const Error404 = React.lazy(() => import("../pages/error/Error404"));
const Error500 = React.lazy(() => import("../pages/error/Error500"));
// -other
const Starter = React.lazy(() => import("../pages/other/Starter"));
const Profile = React.lazy(() => import("../pages/other/Profile"));
const Activity = React.lazy(() => import("../pages/other/Activity"));
const Invoice = React.lazy(() => import("../pages/other/Invoice"));
const Maintenance = React.lazy(() => import("../pages/other/Maintenance"));
const Pricing = React.lazy(() => import("../pages/other/Pricing"));

// uikit
const UIElements = React.lazy(() => import("../pages/uikit"));

// widgets
const Widgets = React.lazy(() => import("../pages/widgets/"));

// icons
const Unicons = React.lazy(() => import("../pages/icons/Unicons"));
const FeatherIcons = React.lazy(() => import("../pages/icons/Feather/"));
const BootstrapIcon = React.lazy(() => import("../pages/icons/Bootstrap/"));

// forms
const BasicForms = React.lazy(() => import("../pages/forms/Basic"));
const FormAdvanced = React.lazy(() => import("../pages/forms/Advanced"));
const FormValidation = React.lazy(() => import("../pages/forms/Validation"));
const FormWizard = React.lazy(() => import("../pages/forms/Wizard"));
const FileUpload = React.lazy(() => import("../pages/forms/FileUpload"));
const Editors = React.lazy(() => import("../pages/forms/Editors"));

// charts
const Charts = React.lazy(() => import("../pages/charts/"));

// tables
const BasicTables = React.lazy(() => import("../pages/tables/Basic"));
const AdvancedTables = React.lazy(() => import("../pages/tables/Advanced"));

// maps
const GoogleMaps = React.lazy(() => import("../pages/maps/GoogleMaps"));
const VectorMaps = React.lazy(() => import("../pages/maps/VectorMaps"));

// Analytics
const TopPerformingViewAll = React.lazy(
  () => import("../pages/analytics/TopPerformingViewAll")
);
const OverviewChartViewAll = React.lazy(
  () => import("../pages/analytics/OverviewChartViewAll")
);

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

// dashboards
const homeRoutes: RoutesProps = {
  path: "/dashboards",
  name: "Dashboards",
  icon: "airplay",
  header: "Navigation",
  children: [
    {
      path: "/",
      name: "Root",
      // element: <Navigate to="/dashboards/ecommerce" />,
      // element: <WatchoDashboard />,
      element: <Navigate to="/dashboards" />,
      route: PrivateRoute,
    },
  ],
};

const HomeDashboard: RoutesProps = {
  path: "/dashboards/",
  name: "Dashboards",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <WatchoDashboard />,
  header: "dashboard",
};

const WatchoContent: RoutesProps = {
  path: "/content/",
  name: "Content",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "content",
  element: <Content />,
  header: "content",
};

const WatchoUpdateVideoContent: RoutesProps = {
  path: "/content/update-content/",
  name: "UpdateContent",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "content",
  element: <UpdateVideoContent />,
  header: "updateContent",
};

const WatchoUpdateShortsContent: RoutesProps = {
  path: "/content/update-shorts/",
  name: "UpdateShorts",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "content",
  element: <UpdateShortsContent />,
  header: "updateShorts",
};

const WatchoUpdateLiveEventContent: RoutesProps = {
  path: "/content/update-live-event/",
  name: "UpdateLiveEvent",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "content",
  element: <UpdateLiveEventContent />,
  header: "updateLiveEvent",
};

const WatchoSeriesDetails: RoutesProps = {
  path: "/content/seriesDetails/",
  name: "SeriesDetails",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "content",
  element: <SeriesDetails />,
  header: "seriesDetails",
};

const WatchoAnalytics: RoutesProps = {
  path: "/analytics/",
  name: "analytics",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Analytics />,
  header: "analytics",
};

const WatchoMonetization: RoutesProps = {
  path: "/monetization/",
  name: "monetization",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Monetization />,
  header: "monetization",
};

const WatchoAnalyticsTopPerforming: RoutesProps = {
  path: "/analytics/top-performing-view-all/",
  name: "TopPerformingViewAll",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "TopPerformingViewAll",
  element: <TopPerformingViewAll />,
  header: "TopPerforming",
};
const WatchoAnalyticsOverviewChartViewAll: RoutesProps = {
  path: "/analytics/overview-chart-view-all/",
  name: "OverviewChartViewAll",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "OverviewChartViewAll",
  element: <OverviewChartViewAll />,
  header: "TopPerforming",
};

const updateKycRoutes: RoutesProps = {
  path: "/monetization/update-kyc",
  name: "UpdateKyc",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "updatekyc",
  element: <UpdateKyc />,
};

const KycRoutes: RoutesProps = {
  path: "/monetization/kyc",
  name: "Kyc",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "updatekyc",
  element: <ManageKyc />,
};

const paymentPageRoutes: RoutesProps = {
  path: "/monetization/payment-page",
  name: "PaymentPage",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "paymentPage",
  element: <PaymentPage />,
};
const payoutDetailsPageRoutes: RoutesProps = {
  path: "/monetization/payoutDetails",
  name: "payoutDetailsPage",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "payoutDetailsPage",
  element: <PayoutDetailsPage />,
};

const paymentLogsRoutes: RoutesProps = {
  path: "/payout-logs",
  name: "PayouttLogs",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "payoutLogs",
  element: <PayoutLogs />,
};
// const paymentLogsRoutes: RoutesProps = {
//   path: "/payout-logs",
//   name: "PayoutLogs",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "payoutLogs",
//   element: <PayoutLogsRouteWrapper />, // Use the wrapper component
// };

const NewMonetizationRoutes: RoutesProps = {
  path: "/monetization-new/",
  name: "Monetization",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Monetisation />,
  header: "monetization",
};

const WatchoPromotion: RoutesProps = {
  path: "/promotions/",
  name: "promotions",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Promotion />,
  header: "promotions",
};

const WatchoChannel: RoutesProps = {
  path: "/channel-customization/",
  name: "channel",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <ChannelCustomization />,
  header: "channel",
};

const WatchoChannelSocialMedia: RoutesProps = {
  path: "/channel-customization/social-media",
  name: "socailmedia",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <ChannelSocialMedia />,
  header: "social",
};

const WatchoProfile: RoutesProps = {
  path: "/profile-setting/",
  name: "profile",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <ProfileSetting />,
  header: "profile",
};

const Watchohelp: RoutesProps = {
  path: "/support-center/",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Help />,
  header: "help",
};

const Watchohelpstarted: RoutesProps = {
  path: "/support-center/getting-started",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <GettingStartedPage />,
  header: "help",
};
const Watchohelpstartedquestions: RoutesProps = {
  path: "/support-center/general-questions",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <GettingStartedQuestions />,
  header: "help",
};
const Watchohelpstartedchannel: RoutesProps = {
  path: "/support-center/channel-creation",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <GettingStartedChannel />,
  header: "help",
};
const Watchohelpstartedcontent: RoutesProps = {
  path: "/support-center/content-management",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <GettingStartedContent />,
  header: "help",
};
const Watchohelpstartedtroubleshoot: RoutesProps = {
  path: "/support-center/troubleshoot",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <GettingStartedTroubleshoot />,
  header: "help",
};
const Watchohelpchannelsub: RoutesProps = {
  path: "/support-center/channel-subscription",
  name: "support-center",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <ChannelSubscription />,
  header: "help",
};
const Watchohelppolicydocument: RoutesProps = {
  path: "/policy-document/",
  name: "policy-document",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <PolicyDocuments />,
  header: "help",
};

const Watchohelppolicyprivacy: RoutesProps = {
  path: "/policy-document/privacy-policy",
  name: "policy-document",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <PolicyPrivacy />,
  header: "help",
};
const Watchohelppolicyterms: RoutesProps = {
  path: "/policy-document/terms-service",
  name: "policy-document",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <PolicyTerms />,
  header: "help",
};
const Watchohelppolicycontentupload: RoutesProps = {
  path: "/policy-document/upload-policy",
  name: "policy-document",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <ContentUpload />,
  header: "help",
};
const Watchohelpsupport: RoutesProps = {
  path: "/support/",
  name: "support",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Support />,
  header: "help",
};
const Watchohelpopenticket: RoutesProps = {
  path: "/support/open-ticket",
  name: "support",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <SupportOpenTicket />,
  header: "help",
};

const Watchohelppolicymonitisationupload: RoutesProps = {
  path: "/policy-document/monitisation-policy",
  name: "monitisation-document",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <ContentMonitisation />,
  header: "help",
};

const WatchoFeedback: RoutesProps = {
  path: "/feedback/",
  name: "feedback",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "contemt",
  element: <Feedback />,
  header: "feedback",
};

const WatchoNotification: RoutesProps = {
  path: "/notification/",
  name: "notification",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "notification",
  element: <Notification />,
  header: "notification",
};

const calendarAppRoutes: RoutesProps = {
  path: "/apps/calendar",
  name: "Calendar",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "calendar",
  element: <CalendarApp />,
  header: "Apps",
};

const chatAppRoutes: RoutesProps = {
  path: "/apps/chat",
  name: "Chat",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ChatApp />,
};

const emailAppRoutes: RoutesProps = {
  path: "/apps/email",
  name: "Email",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "mail",
  children: [
    {
      path: "/apps/email/inbox",
      name: "Inbox",
      element: <Inbox />,
      route: PrivateRoute,
    },
    {
      path: "/apps/email/details",
      name: "Email Details",
      element: <EmailDetail />,
      route: PrivateRoute,
    },
    {
      path: "/apps/email/compose",
      name: "Compose Email",
      element: <EmailCompose />,
      route: PrivateRoute,
    },
  ],
};

const projectAppRoutes: RoutesProps = {
  path: "/apps/projects",
  name: "Projects",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "uil-briefcase",

  children: [
    {
      path: "/apps/projects/list",
      name: "List",
      element: <Projects />,
      route: PrivateRoute,
    },
    {
      path: "/apps/projects/details",
      name: "Detail",
      element: <ProjectDetail />,
      route: PrivateRoute,
    },
  ],
};

const taskAppRoutes: RoutesProps = {
  path: "/apps/tasks",
  name: "Tasks",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "clipboard",
  children: [
    {
      path: "/apps/tasks/list",
      name: "Task List",
      element: <TaskList />,
      route: PrivateRoute,
    },
    {
      path: "/apps/tasks/kanban",
      name: "Kanban",
      element: <Kanban />,
      route: PrivateRoute,
    },
  ],
};

const fileAppRoutes: RoutesProps = {
  path: "/apps/file-manager",
  name: "File Manager",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "folder-plus",
  element: <FileManager />,
};

const appRoutes = [
  calendarAppRoutes,
  chatAppRoutes,
  emailAppRoutes,
  projectAppRoutes,
  taskAppRoutes,
  fileAppRoutes,
];

// pages
const extrapagesRoutes: RoutesProps = {
  path: "/pages",
  name: "Pages",
  icon: "package",
  header: "Custom",
  children: [
    {
      path: "/pages/starter",
      name: "Starter",
      element: <Starter />,
      route: PrivateRoute,
    },
    {
      path: "/pages/profile",
      name: "Profile",
      element: <Profile />,
      route: PrivateRoute,
    },
    {
      path: "/pages/activity",
      name: "Activity",
      element: <Activity />,
      route: PrivateRoute,
    },
    {
      path: "/pages/invoice",
      name: "Invoice",
      element: <Invoice />,
      route: PrivateRoute,
    },
    {
      path: "/pages/pricing",
      name: "Pricing",
      element: <Pricing />,
      route: PrivateRoute,
    },
  ],
};

// ui
const uiRoutes: RoutesProps = {
  path: "/components",
  name: "Components",
  icon: "package",
  header: "UI Elements",
  children: [
    {
      path: "/components/ui-elements",
      name: "UIElements",
      element: <UIElements />,
      route: PrivateRoute,
    },
    {
      path: "/components/widgets",
      name: "Widgets",
      element: <Widgets />,
      route: PrivateRoute,
    },
    {
      path: "/icons",
      name: "Icons",
      children: [
        {
          path: "/icons/unicons",
          name: "Unicons",
          element: <Unicons />,
          route: PrivateRoute,
        },
        {
          path: "/icons/feather",
          name: "Feather",
          element: <FeatherIcons />,
          route: PrivateRoute,
        },
        {
          path: "/icons/bootstrap",
          name: "Bootstrap Icon",
          element: <BootstrapIcon />,
          route: PrivateRoute,
        },
      ],
    },
    {
      path: "/forms",
      name: "Forms",
      children: [
        {
          path: "/forms/basic",
          name: "Basic Elements",
          element: <BasicForms />,
          route: PrivateRoute,
        },
        {
          path: "/forms/advanced",
          name: "Form Advanced",
          element: <FormAdvanced />,
          route: PrivateRoute,
        },
        {
          path: "/forms/validation",
          name: "Form Validation",
          element: <FormValidation />,
          route: PrivateRoute,
        },
        {
          path: "/forms/wizard",
          name: "Form Wizard",
          element: <FormWizard />,
          route: PrivateRoute,
        },
        {
          path: "/forms/upload",
          name: "File Upload",
          element: <FileUpload />,
          route: PrivateRoute,
        },
        {
          path: "/forms/editors",
          name: "Editors",
          element: <Editors />,
          route: PrivateRoute,
        },
      ],
    },
    {
      path: "/components/charts",
      name: "Charts",
      element: <Charts />,
      route: PrivateRoute,
    },
    {
      path: "/tables",
      name: "Tables",
      children: [
        {
          path: "/tables/basic",
          name: "Basic",
          element: <BasicTables />,
          route: PrivateRoute,
        },
        {
          path: "/tables/advanced",
          name: "Advanced",
          element: <AdvancedTables />,
          route: PrivateRoute,
        },
      ],
    },
    {
      path: "/maps",
      name: "Maps",
      children: [
        {
          path: "/maps/googlemaps",
          name: "Google Maps",
          element: <GoogleMaps />,
          route: PrivateRoute,
        },
        {
          path: "/maps/vectorMaps",
          name: "Google Maps",
          element: <VectorMaps />,
          route: PrivateRoute,
        },
      ],
    },
  ],
};

// auth
const authRoutes: RoutesProps[] = [
  // {
  //   path: "/auth/login",
  //   name: "Login",
  //   element: <Login />,
  //   route: Route,
  // },
  {
    path: "/auth/signup",
    name: "Signup",
    element: <MobileSignup />,
    route: Route,
  },
  {
    path: "/auth/login",
    name: "Login",
    element: <MobileLogin />,
    route: Route,
  },
  {
    path: "/auth/mobilelogin",
    name: "Login",
    element: <MobileLogin />,
    route: Route,
  },
  {
    path: "/auth/register",
    name: "Register",
    element: <Register />,
    route: Route,
  },
  {
    path: "/auth/confirm",
    name: "Confirm",
    element: <Confirm />,
    route: Route,
  },
  {
    path: "/auth/forget-password",
    name: "Forget Password",
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: "/auth/lock-screen",
    name: "Lock Screen",
    element: <LockScreen />,
    route: Route,
  },
  {
    path: "/auth/logout",
    name: "Logout",
    element: <Logout />,
    route: Route,
  },
];

// public routes
const otherPublicRoutes: RoutesProps[] = [
  {
    path: "/landing",
    name: "landing",
    element: <Landing />,
    route: Route,
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    element: <Maintenance />,
    route: Route,
  },
  {
    path: "/error-404",
    name: "Error - 404",
    element: <Error404 />,
    route: Route,
  },
  {
    path: "/error-500",
    name: "Error - 500",
    element: <Error500 />,
    route: Route,
  },
  {
    path: "*",
    name: "Catch Up Route",
    element: <Error404 />,
    // element: <Navigate to="/error-404" />,
    route: Route,
  },
];

// create channel routes
const createChannelRoutes: RoutesProps[] = [
  {
    path: "/create-channel",
    name: "create channel",
    element: <CreateChannel />,
    route: Route,
  },
  {
    path: "/creator-agreement",
    name: "create channel",
    element: <CreatorAgreement />,
    route: Route,
  },
];

const WatchoCreatorInfo: RoutesProps[] = [
  {
    path: "/creator-info",
    name: "creator info",
    element: <CreatorInfo />,
    route: Route,
  },
];

const WatchoAddChannel: RoutesProps[] = [
  {
    path: "/add-channel",
    name: "add channel",
    element: <CreatorInfo />,
    route: Route,
  },
];

// Term of use routes
const WatchoTermsOfUse: RoutesProps[] = [
  {
    path: "/terms-of-use",
    name: "term of use",
    element: <ContentTerms />,
    route: Route,
  },
];

// Privacy Policy routes
const WatchoPrivacyPolicy: RoutesProps[] = [
  {
    path: "/privacy-policy",
    name: "privacy policy",
    element: <ContentPrivacy />,
    route: Route,
  },
];

// Content Creator Privacy Policy routes
const WatchoContentCreatorPrivacyPolicy: RoutesProps[] = [
  {
    path: "/content-creator-privacy-policy",
    name: "content creator privacy policy",
    element: <ContentCreatorPrivacyPolicy />,
    route: Route,
  },
];

// Content Guidelines Policy routes
const WatchoContentGuidelinesPolicy: RoutesProps[] = [
  {
    path: "/content-guidelines-policy",
    name: "content guidelines policy",
    element: <ContentGuidelinesPolicy />,
    route: Route,
  },
];

// Content Take-down Policy routes
const WatchoContentTakeDownPolicy: RoutesProps[] = [
  {
    path: "/content-take-down-policy",
    name: "content take down policy",
    element: <ContentTakeDownPoilcy />,
    route: Route,
  },
];

// Content Creator Agreement routes
const WatchoContentCreatorAgreement: RoutesProps[] = [
  {
    path: "/content-creator-agreement",
    name: "content creator agreement",
    element: <CreatorAgreement />,
    route: Route,
  },
];

// Monetization Policy routes
const WatchoMonetizationPolicy: RoutesProps[] = [
  {
    path: "/monetization-policy",
    name: "privacy policy",
    element: <MonetizationPrivacy />,
    route: Route,
  },
];

// Do and Donts routes
const WatchoDoDonts: RoutesProps[] = [
  {
    path: "/do-donts",
    name: "do and donts",
    element: <DoDonts />,
    route: Route,
  },
];

// Content Policy routes
const WatchoContentPolicy: RoutesProps[] = [
  {
    path: "/content-privacy-policy",
    name: "content privacy policy",
    element: <ContentUploadPrivacy />,
    route: Route,
  },
];

// FAQ routes
const Watchofaq: RoutesProps[] = [
  {
    path: "/faq",
    name: "faq",
    element: <FaqDocuments />,
    route: Route,
  },
];

// /know more/channel subscription routes
const knowMoreRoutes: RoutesProps[] = [
  {
    path: "/know-more/channel-subscription",
    name: "know-more",
    element: <ChannelSubscription />,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [
  homeRoutes,
  HomeDashboard,
  WatchoContent,
  WatchoUpdateVideoContent,
  WatchoUpdateShortsContent,
  WatchoUpdateLiveEventContent,
  WatchoSeriesDetails,
  WatchoAnalytics,
  WatchoAnalyticsTopPerforming,
  WatchoAnalyticsOverviewChartViewAll,
  WatchoMonetization,
  NewMonetizationRoutes,
  paymentLogsRoutes,
  paymentPageRoutes,
  payoutDetailsPageRoutes,
  updateKycRoutes,
  KycRoutes,
  WatchoPromotion,
  WatchoChannel,
  WatchoChannelSocialMedia,
  WatchoProfile,
  Watchohelp,
  Watchohelpstarted,
  Watchohelpstartedquestions,
  Watchohelpstartedchannel,
  Watchohelpstartedcontent,
  Watchohelpstartedtroubleshoot,
  Watchohelpchannelsub,
  Watchohelppolicydocument,
  Watchohelppolicyprivacy,
  Watchohelppolicyterms,
  Watchohelppolicycontentupload,
  Watchohelpsupport,
  Watchohelpopenticket,
  Watchohelppolicymonitisationupload,
  WatchoFeedback,
  WatchoNotification,
  ...appRoutes,
  extrapagesRoutes,
  uiRoutes,
];
const publicRoutes = [
  ...authRoutes,
  ...otherPublicRoutes,
  ...createChannelRoutes,
  ...WatchoCreatorInfo,
  ...WatchoAddChannel,
  ...WatchoTermsOfUse, // Terms Of Use without login
  ...WatchoPrivacyPolicy, // Privacy Policy without login
  ...WatchoContentCreatorPrivacyPolicy, // Content Creator Privacy Policy without login
  ...WatchoContentGuidelinesPolicy, // Content Guidelines Policy without login
  ...WatchoContentTakeDownPolicy, // Content Take-Down Policy without login
  ...WatchoContentCreatorAgreement, // Content Creator Agreement without login
  ...WatchoMonetizationPolicy, // Monetization Policy without login
  ...WatchoDoDonts,
  ...WatchoContentPolicy, // Content Privacy Policy without login
  ...Watchofaq, // FAQ without login
  ...knowMoreRoutes,
];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
